import { render, staticRenderFns } from "./WidgetCardsBuffer.vue?vue&type=template&id=48919015&scoped=true"
import script from "./WidgetCardsBuffer.vue?vue&type=script&lang=js"
export * from "./WidgetCardsBuffer.vue?vue&type=script&lang=js"
import style0 from "./WidgetCardsBuffer.vue?vue&type=style&index=0&id=48919015&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48919015",
  null
  
)

export default component.exports